import { Form, SubmitButton, TextAreaInputField } from '@/components';
import { ProjectOtherNotesFormSchema } from '@/features/project/projects/_models/project';
import { useForm } from '@/hooks';
import type { sheetTypeEnum } from '@/utils/enum';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof ProjectOtherNotesFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
  type?: 'basic' | 'skipped-review';
  sheetType: z.infer<typeof sheetTypeEnum>;
};

export const ProjectOtherNotesForm: FC<Props> = ({
  initialValues,
  onSubmit,
  type = 'basic',
  sheetType,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(ProjectOtherNotesFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextAreaInputField
        fallbackValue={null}
        name="increaseDecreaseMainReason"
        label={t('increase-decrease-main-reason')}
        hint={
          type === 'basic' && sheetType !== 'KS'
            ? t('hint-increase-decrease-main-reason')
            : undefined
        }
        control={control}
        errors={errors}
        rows={5}
      />

      <TextAreaInputField
        fallbackValue={null}
        name="otherSpecialNotes"
        label={t('other-special-notes')}
        hint={t('hint-other-special-notes')}
        control={control}
        errors={errors}
        rows={5}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
